"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApplicationAccessDetails = exports.hasLookerAccess = exports.initializePortalToken = exports.PortalAuthenticationTypes = void 0;
exports.initialiazeTokenForUser = initialiazeTokenForUser;
const axios_1 = __importDefault(require("axios"));
const auth_1 = require("./auth");
const internalAxios_1 = require("./internalAxios");
const utils_1 = require("./utils");
var PortalAuthenticationTypes;
(function (PortalAuthenticationTypes) {
    PortalAuthenticationTypes[PortalAuthenticationTypes["Unauthenticated"] = 0] = "Unauthenticated";
    PortalAuthenticationTypes[PortalAuthenticationTypes["IsAuthenticating"] = 1] = "IsAuthenticating";
    PortalAuthenticationTypes[PortalAuthenticationTypes["Authenticated"] = 2] = "Authenticated";
})(PortalAuthenticationTypes || (exports.PortalAuthenticationTypes = PortalAuthenticationTypes = {}));
const initializeLookerCredentials = async () => {
    try {
        const { data: embedUserDto } = await internalAxios_1.internalAxios.get('/api/looker-account/initialization');
        (0, utils_1.setLocalStorageItems)(embedUserDto);
        return true;
    }
    catch (err) {
        console.error('Looker Account Initialization was not successful');
        return false;
    }
};
async function initialiazeTokenForUser() {
    try {
        const { data } = await axios_1.default.get('/redirect');
        window.location = data.redirectUrl;
    }
    catch (err) {
        if (err.status === 500) {
            throw new Error('Token could not be granted');
        }
        else {
            throw err;
        }
    }
}
const initializePortalToken = async () => {
    try {
        const accessToken = localStorage.getItem('accessToken');
        if (!accessToken || accessToken === undefined) {
            await initialiazeTokenForUser();
            return PortalAuthenticationTypes.IsAuthenticating;
        }
        const refreshToken = localStorage.getItem('refreshToken');
        if (accessToken && refreshToken) {
            await (0, auth_1.refresh)(refreshToken, accessToken);
            return PortalAuthenticationTypes.Authenticated;
        }
        return PortalAuthenticationTypes.Unauthenticated;
    }
    catch {
        return PortalAuthenticationTypes.Unauthenticated;
    }
};
exports.initializePortalToken = initializePortalToken;
const hasLookerAccess = async () => {
    if (localStorage.getItem('user_external_id'))
        return true;
    return await initializeLookerCredentials();
};
exports.hasLookerAccess = hasLookerAccess;
const getApplicationAccessDetails = async () => {
    try {
        const authorization = localStorage.getItem('accessToken');
        const config = {
            headers: {
                Authorization: authorization,
            },
        };
        const { data } = await internalAxios_1.internalAxios.get('/api/looker-account/apps', config);
        return data;
    }
    catch (err) {
        throw new Error('could not get application access details');
    }
};
exports.getApplicationAccessDetails = getApplicationAccessDetails;
